import React from "react";
import { BrowserRouter, Routes as Switch, Route } from "react-router-dom";
import Navbar from "./PortfolioContainer/Header/Navbar";
import About from './PortfolioContainer/AboutMe/About';
import Home from './PortfolioContainer/Home/Home';
import Experience from './PortfolioContainer/Experience/Experience';
import Projects from './PortfolioContainer/Projects/Projects';
import Example from './PortfolioContainer/Projects/Example';

import HireMe from './PortfolioContainer/ContactMe/HireMe';
import Footer from "./PortfolioContainer/Footer/Footer";


function App() {
  return (
    <BrowserRouter>
    <Navbar />
<Switch>
<Route path="/" element={<Home />}></Route>
  <Route path="/aboutme" element={<About />}></Route>
  <Route path="/experience" element={<Experience />}></Route>
  <Route path="/projects" element={<Projects />}></Route>
  <Route path="/hireme" element={<HireMe />}></Route>  
  <Route path="/example" element={<Example />}></Route> 
</Switch>



<Footer />
    
    
    
  
  
    </BrowserRouter>

  );
}

export default App;
